import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFullIconLargeInactive = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={100} height={56.25} {...props}>
    <g data-name="White Box">
      <path fill="#fff" d="M99.5 55.751H.5V.501h99Z" data-name="Path 1" />
      <path
        fill="#ccd3da"
        d="M1 1v54.25h98V1zM0 0h100v56.25H0Z"
        data-name="Path 2"
      />
    </g>
    <path fill="#ccd3da" d="M3 3h94.043v50.188H3Z" data-name="Grey Box" />
  </svg>
);
export default SvgFullIconLargeInactive;
